import * as yup from 'yup';
import { EditorWrapperState } from '@wix/da-shared-react/pkg/DaEditorWrapper/types';

export const validationSchema = yup.object({
  title: yup.string(),
  tagline: yup.string(),
  description: yup.object<EditorWrapperState>().required(),
});
